<div>
  <span class="icon-area">
    @if (job.progressState === 'InProgress') {
      <gbc-simple-spinner class="spinner progress-checker-in-progress"></gbc-simple-spinner>
    }
    @if (job.progressState === 'CompletedWithSuccess' && job?.result === true) {
      <span
        class="progress-checker-result-success">
        <img class="icon" src="./assets/svgs/check-outline-green.svg" />
      </span>
    }
    @if ((job.progressState === 'CompletedWithSuccess' && job?.result === false) || (job.progressState === 'CompletedWithError')) {
      <span
        class="progress-checker-result-error">
        <img class="icon" src="./assets/svgs/close_outline-red.svg" />
      </span>
    }
  </span>
  <span>{{title}}</span>
  @if (showErrorMessage && job?.progressState === 'CompletedWithError') {
    <span>
      <img class="info-img" src="./assets/svgs/info-circle_outline.svg" [title]="job?.errorMessage" />
    </span>
  }
</div>